import { createPortal } from 'react-dom';
import { useUIStore, type Toast as ToastType } from '@/store/uiStore';
import styles from './Toast.module.css';

const ICONS: Record<ToastType['variant'], string> = {
  success: 'fa-circle-check',
  error: 'fa-circle-xmark',
  warning: 'fa-triangle-exclamation',
  info: 'fa-circle-info',
};

function ToastItem({ toast }: { toast: ToastType }) {
  const removeToast = useUIStore((s) => s.removeToast);

  return (
    <div className={[styles.toast, styles[toast.variant]].join(' ')} role="alert">
      <i className={`fa-solid ${ICONS[toast.variant]} ${styles.icon}`} aria-hidden="true" />
      <span className={styles.message}>{toast.message}</span>
      <button
        className={styles.dismiss}
        onClick={() => removeToast(toast.id)}
        aria-label="Dismiss"
      >
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </button>
    </div>
  );
}

/** Render this once in App.tsx — it displays all active toasts */
export function ToastContainer() {
  const toasts = useUIStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return createPortal(
    <div className={styles.container} aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>,
    document.body
  );
}
